import React from "react";
//loading state for login
function Loading() {
  return (
    <div
      className="d-flex justify-content-center align-items-center loader"
      style={{ color: "#1D946B" }}
    >
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default Loading;
